<template>
  <div class="index-container">
    <base-station></base-station>
  </div>
</template>

<script>
import BaseStation from "./components/baseStation.vue"
export default {
  components: { BaseStation },
  data () {
    return {
      tabType: 'station'
    }
  },
  methods: {
    tabClick (val) {
      this.tabType = val
    }
  }
}
</script>


<style lang="scss">
.index-container {
  width: 100%;
  height: 100%;
  .tab-btn {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #2a2b2c;
    display: flex;
    align-items: center;
    padding: 0px 8px;
    cursor: pointer;
    font-size: 12px;
  }
  .tab-btn.selected {
    background: #0080ff;
    border: 1px solid #0080ff;
    color: #fff;
  }
}
</style>